import React from 'react';
import { Link } from 'react-router-dom';
import { ButtonSecondary } from '@components/button';
import { BUTTON_VARIANT_FILL, BUTTON_VARIANT_S } from '@components/button/src/config';
import { SubmenuIcon } from '@components/submenu-with-icon';

import { EventHeaderActionsProps } from './event-header-actions.type';

export const EventHeaderActions = ({
  isPublished,
  isLiveEvent,
  isLessThanTablet,
  reportPath,
  publishedActions,
  unpublishedActions,
  buttonReportText,
  buttonPreviewText,
  buttonViewText,
  openPreview,
}: EventHeaderActionsProps) => {
  // Unpublished events
  if (!isPublished) {
    return (
      <>
        {!isLessThanTablet && (
          <ButtonSecondary className='whitespace-nowrap' variant={BUTTON_VARIANT_S} onClick={() => openPreview()}>
            {buttonPreviewText}
          </ButtonSecondary>
        )}
        <SubmenuIcon options={unpublishedActions} variant={BUTTON_VARIANT_FILL} />
      </>
    );
  }

  // Published events - mobile
  if (isLessThanTablet) {
    return <SubmenuIcon options={publishedActions} variant={BUTTON_VARIANT_FILL} />;
  }

  // Published events - desktop with live event
  if (isLiveEvent) {
    return (
      <>
        <ButtonSecondary className='whitespace-nowrap' variant={BUTTON_VARIANT_S} onClick={() => openPreview()}>
          {buttonViewText}
        </ButtonSecondary>
        <SubmenuIcon options={publishedActions} variant={BUTTON_VARIANT_FILL} />
      </>
    );
  }

  // Published events - desktop without live event
  return (
    <>
      <Link to={reportPath as string}>
        <ButtonSecondary className='whitespace-nowrap' variant={BUTTON_VARIANT_S}>
          {buttonReportText}
        </ButtonSecondary>
      </Link>
      <SubmenuIcon options={publishedActions} variant={BUTTON_VARIANT_FILL} />
    </>
  );
};
